import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import classNames from "classnames";

const Container = styled.div.attrs({ className: "input" })`
  background: ${props => props.theme.colors.white};
  border: 1px solid;
  border-color: ${props => props.theme.colors.iron};
  border-radius: 2px;
  color: ${props => props.theme.colors.mako};
  display: flex;
  height: 52px;
  padding: 0 16px;

  &&&&&&& {
    font-family: Roboto !important;
  }

  &.active,
  &.active.inline {
    border-color: ${props => props.theme.colors.solera};
  }
  &.error,
  &.error input {
    background: ${props => props.theme.colors.monzaLightest};
  }
  &.error {
    border-color: ${props => props.theme.colors.monza};
  }
  &.inline,
  &.naked {
    background: transparent;
    height: 36px;
    border: none;
    padding: 0;
  }
  &.inline {
    border-bottom: 2px solid;
    border-bottom-color: ${props => props.theme.colors.iron};
  }
  &.inline.error {
    border-bottom-color: ${props => props.theme.colors.monza};
  }
  &.inline.error input {
    background: transparent;
    color: ${props => props.theme.colors.monza};
  }
  &.inline.disabled {
    border: 1px solid;
    border-color: ${props => props.theme.colors.iron};
    padding: 0 16px;
  }
  &.disabled,
  &.disabled.inline,
  && input:disabled {
    background: ${props => props.theme.colors.silverAlt};
    border-color: ${props => props.theme.colors.iron};
    color: ${props => props.theme.colors.mako};
  }

  & input {
    border: none;
    color: ${props => props.theme.colors.mako};
    flex: 1;
    font-size: 14px;
    outline: none;
  }

  & .icon-right,
  & .icon-left {
    align-items: center;
    display: flex;
  }
  & .icon-left {
    float: left;
    margin: 0 8px 0 0;
  }
  & .icon-right {
    float: right;
    margin: 0 0 0 8px;
  }
`;

const UIInput = React.forwardRef(
  (
    {
      error,
      inline,
      onBlur,
      onFocus,
      disabled,
      iconLeft,
      inputRef,
      iconRight,
      className,
      containerProps,
      ...rest
    },
    ref
  ) => {
    const [isActive, setIsActive] = useState(false);
    const handleFocus = event => {
      setIsActive(true);
      onFocus && onFocus(event);
    };
    const handleBlur = event => {
      setIsActive(false);
      onBlur && onBlur(event);
    };

    const leftIconOrNull = iconLeft ? (
      <span className="icon-left">{iconLeft}</span>
    ) : null;
    const rightIconOrNull = iconRight ? (
      <span className="icon-right">{iconRight}</span>
    ) : null;

    return (
      <Container
        className={classNames(className, {
          active: isActive,
          error,
          inline,
          disabled
        })}
        {...containerProps}
      >
        {leftIconOrNull}
        <input
          type="text"
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={disabled}
          ref={ref}
          {...rest}
        />
        {rightIconOrNull}
      </Container>
    );
  }
);

UIInput.propTypes = {
  error: PropTypes.bool,
  inline: PropTypes.bool,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  disabled: PropTypes.bool,
  iconLeft: PropTypes.element,
  iconRight: PropTypes.element,
  containerProps: PropTypes.object
};

UIInput.defaultProps = {
  error: false,
  inline: false
};

export default UIInput;
